import React from 'react';

const BADriverInfoIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.9349 16.7146C14.7479 15.5395 14.1479 14.4696 13.2427 13.6971C12.3375 12.9247 11.1866 12.5004 9.99662 12.5005C8.80668 12.5006 7.65579 12.9251 6.75076 13.6977C5.84573 14.4703 5.2459 15.5403 5.05906 16.7155M13.3307 9.16797C13.3307 11.0089 11.8383 12.5013 9.9974 12.5013C8.15645 12.5013 6.66406 11.0089 6.66406 9.16797C6.66406 7.32702 8.15645 5.83464 9.9974 5.83464C11.8383 5.83464 13.3307 7.32702 13.3307 9.16797ZM18.3307 10.0013C18.3307 14.6037 14.5998 18.3346 9.9974 18.3346C5.39502 18.3346 1.66406 14.6037 1.66406 10.0013C1.66406 5.39893 5.39502 1.66797 9.9974 1.66797C14.5998 1.66797 18.3307 5.39893 18.3307 10.0013Z'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default BADriverInfoIcon;
